export enum FundCardLayoutMode {
	Standard = 'standard',
	ESG = 'esg',
}

export type DataPointsType =
	| 'nav'
	| 'net'
	| 'buy'
	| 'assets'
	| 'carbs'
	| 'inceptionNav'
	| 'inceptionNet'
	| 'esg';

export type UserTypes =
	| 'institutional'
	| 'individual'
	| 'financial-professionals'
	| 'intermediaries';

export type Regions = 'us' | 'amer' | 'apac' | 'emea';

export type Appearance = 'block' | 'primary' | 'standard';

export type FundType = 'index' | 'etf';

export type Colors =
	| ''
	| 'white'
	| 'blue'
	| 'purple'
	| 'pink'
	| 'green'
	| 'yellow'
	| 'black';

export type EsgVisibilityStyle = 'none' | 'flex';

export type ApiComponentName =
	| 'fundheader'
	| 'keyfundfacts'
	| 'esgAnalytics'
	| 'riskIndicator';
